// Non-default languages. Lithuanian (lt) is the default and uses no path suffix.
const NON_DEFAULT_LANGS = ['en', 'ru'];
const LANG_SUFFIX_RE = new RegExp(`/(${NON_DEFAULT_LANGS.join('|')})/?$`);

export function langPathSuffix(lang) {
  return lang && lang !== 'lt' ? `${lang}/` : '';
}

export function switchLang(pathname, targetLang) {
  const base = pathname.replace(LANG_SUFFIX_RE, '/');
  return targetLang === 'lt' ? base : `${base}${targetLang}/`;
}
